<h2 mat-dialog-title>
  <mat-icon class="titel-icon">merge_type</mat-icon>
  Synchronisierungskonflikt
</h2>

<mat-dialog-content>

  <p class="einleitung">
    Diese Änderungen wurden am Server bereits von jemand anderem überschrieben.
    Sie wurden deshalb <strong>nicht</strong> übernommen – bitte entscheiden,
    welche Fassung gelten soll.
  </p>


  <div class="laden" *ngIf="isLoading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>


  <div
    class="konflikt"
    *ngFor="let k of konflikte; trackBy: trackByKonflikt">

    <div class="konflikt-kopf">
      <span class="konflikt-titel">{{ k.bezeichnung }}</span>
      <span class="konflikt-feld">{{ k.feld }}</span>
    </div>

    <div class="fassungen">

      <div class="fassung fassung-server">
        <span class="fassung-label">Server</span>
        <span class="fassung-wert">{{ k.serverText }}</span>
        <span class="fassung-meta" *ngIf="k.serverBenutzer">
          {{ k.serverBenutzer }}
        </span>
        <span class="fassung-meta" *ngIf="k.serverZeitpunktUtc">
          {{ k.serverZeitpunktUtc | date:'dd.MM.yyyy HH:mm' }}
        </span>
      </div>

      <div class="fassung fassung-lokal">
        <span class="fassung-label">Offline erfasst</span>
        <span class="fassung-wert">{{ k.lokalText }}</span>
        <span class="fassung-meta">
          {{ k.aenderung.performedAtUtc | date:'dd.MM.yyyy HH:mm' }}
        </span>
      </div>

    </div>

    <div class="konflikt-aktionen">
      <button
        mat-stroked-button
        type="button"
        [disabled]="laufend.has(k.id)"
        (click)="serverfassung(k)">
        Serverversion übernehmen
      </button>

      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="laufend.has(k.id)"
        (click)="lokaleFassung(k)">
        Lokale Änderung übernehmen
      </button>
    </div>

  </div>


  <!--
    ENDGÜLTIG ABGELEHNTE ÄNDERUNGEN

    Erneutes Senden ändert hier nichts – fachlich falsch, ohne Berechtigung
    oder auf einen gelöschten Datensatz. Sie bleiben trotzdem sichtbar: der
    Benutzer soll erfahren, was NICHT angekommen ist, statt es stillschweigend
    zu verlieren.
  -->
  <div class="fehler-block" *ngIf="!isLoading && fehlgeschlagen.length > 0">

    <h3 class="fehler-titel">
      <mat-icon>report_problem</mat-icon>
      Nicht übertragene Änderungen
    </h3>

    <p class="fehler-hinweis">
      Der Server hat diese Änderungen abgelehnt. Ein erneuter Versuch würde
      nichts ändern – bitte prüfen und gegebenenfalls von Hand nachtragen.
    </p>

    <div
      class="fehler-zeile"
      *ngFor="let f of fehlgeschlagen; trackBy: trackByFehler">

      <span class="fehler-typ">{{ typText(f.typ) }}</span>
      <span class="fehler-zeit">
        {{ f.performedAtUtc | date:'dd.MM.yyyy HH:mm' }}
      </span>
      <span class="fehler-text">{{ f.letzterFehler }}</span>
    </div>

    <div class="fehler-aktionen">
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="verwerfeFehlgeschlagene()">
        <mat-icon>delete_outline</mat-icon>
        Endgültig verwerfen
      </button>
    </div>

  </div>


  <p
    class="leer"
    *ngIf="!isLoading && konflikte.length === 0 && fehlgeschlagen.length === 0">
    Es ist nichts offen.
  </p>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="schliessen()">Schließen</button>
</mat-dialog-actions>
